import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { SegmentSettings, SegmentSettingsUpdate } from '../interfaces/accounting.interface';

export const SegmentSettingsService = {
    get: async (): Promise<SegmentSettings> => {
        const institutionId = AuthService.getSelectedInstitution();
        const res = await axios.get(ENDPOINTS.SEGMENT_SETTINGS.BY_INSTITUTION(institutionId!));
        return res.data;
    },
    update: async (dto: SegmentSettingsUpdate): Promise<SegmentSettings> => {
        const institutionId = AuthService.getSelectedInstitution();
        const res = await axios.put(ENDPOINTS.SEGMENT_SETTINGS.UPDATE(institutionId!), dto);
        return res.data;
    },
};
